import type { ComponentClass, FunctionComponent } from "react";

/**
 * Check if a component is a class component.
 * @param Component
 * @returns {boolean}
 */
export function isClassComponent(Component: any): Component is ComponentClass {
  return !!(
    typeof Component === "function" &&
    Component.prototype &&
    Component.prototype.isReactComponent
  );
}

export function isFunctionComponent(
  Component: any,
): Component is FunctionComponent {
  return typeof Component === "function";
}
